import { useContext, useEffect, useState } from 'react';
import './ProductCard.css';
import { ConfigContext } from '../../../assets/contexts/configContext';
import { Link, useNavigate } from 'react-router-dom';
import { ARTICL_NAME, CART_MAIN_LINK, CATALOG_ITEM_LINK, CATALOG_MAIN_LINK, IMG_PLACEHOLDER_PRODUCT, POSSIBLE_CONDITION, RECENTLY_VIEW_LS_KEY } from '../../../assets/utils/constants';
import { buildCategoryPath, compareOptions, getMinPrice, parsePrice, parseTitleForParts } from '../../../assets/utils/utils';
import { CartIcon } from '../../../assets/icons/icons';
import ImageWithBackground from '../../ImageWithBackground/ImageWithBackground';
import { CartContext } from '../../../assets/contexts/cartContext';

const CARD_LAYOUT_TYPES = {
    TITLE: 'item_name',
    DESCRIPTION: 'description',
    IMAGE: 'image',
    BUTTON: 'price',

}

const PRICE_FORMATS = {
    SEPARATELY: 'separately',
    ON_BUTTON: 'on_button',
}

const BUY_BTN_FORMATS = {
    TEXT: 'text',
    BUTTON: 'button',
}

function ProductCard({
    item, path
}) {

    const config = useContext(ConfigContext)
    const { cardTokens, initialConstants } = config
    const { CONSTANTS } = initialConstants
    const { ENABLE_PHOTO_AUTOADJUST = true } = CONSTANTS
    const {
        // cards_in_line,
        but_btn_format,
        image_format,
        image_radius,
        layout,
        price_format,
    } = cardTokens
    // Reverse the array and store it
    const reversedArray = [...item.categories[0].parents].reverse();

    // const [bgColor, setBgColor] = useState('transparent');

    // useEffect(() => {
    //     Vibrant.from(src).getPalette()
    //       .then(palette => {
    //         const rgbColor = palette.Vibrant?.getRgb();
    //         if (rgbColor) {
    //           setBgColor(`rgb(${rgbColor[0]}, ${rgbColor[1]}, ${rgbColor[2]})`);
    //         }
    //       })
    //       .catch(err => console.error('Error extracting color:', err));
    //   }, [src]);

    const cart_context = useContext(CartContext)
    const {
        cart,
        handleAddToCart,
        handleRemoveFromCart,
        // setCart,
    } = cart_context


    const inCart = item && cart && cart.find((cart_item) => {
        if (cart_item._id !== item._id) {
            return false; // Skip items with a different ID early
        }
        // If the item has options and selectedOptions are provided, compare them
        if (cart_item.options && cart_item.options.length > 0) {
            return false
        } else {
            // If there are no options to compare, just check the _id
            return true;
        }
    });
    const navigate = useNavigate()
    const in_stock = item ? item.options.length === 1 ? true : item.price_data.in_stock : null
    function handleCartClick(e) {
        if (!in_stock) return
        if (!item.options || item.options.length === 0) {
            e.preventDefault(); // Prevent default button action
            e.stopPropagation(); // Stop the event from bubbling up
            if (inCart) {
                navigate(`/${CART_MAIN_LINK}`);
                return;
            }
            console.log(item)
            const product_to_card = {
                ...item,
                options: null,
                // selected_size: selectedSize,
                count: 1,
            };
            console.log(product_to_card);
            handleAddToCart(product_to_card);
        }
    }


    const in_cart_text = inCart ? 'В корзине ›' : 'В корзину'
    const price = item.options && item.options.length === 1 ? getMinPrice(item.options[0].values) : item.price_data.price

    function saveRecentlyView(item) {
        let arr = JSON.parse(localStorage.getItem(RECENTLY_VIEW_LS_KEY)) || [];
        const newItem = item._id;
        if (!newItem) {
            return;
        }
        const index = arr.indexOf(newItem);
        if (index !== -1) {
            arr.splice(index, 1);
        }
        arr.push(newItem);
        localStorage.setItem(RECENTLY_VIEW_LS_KEY, JSON.stringify(arr));
    }

    const [isLiked, setIsLiked] = useState(false);

    // Utility functions for managing local storage
    const getLikedProducts = () => JSON.parse(localStorage.getItem('likedProducts')) || [];
    const saveLikedProducts = (likedProducts) => localStorage.setItem('likedProducts', JSON.stringify(likedProducts));

    // Check if the product is liked on component mount
    useEffect(() => {
        const likedProducts = getLikedProducts();
        setIsLiked(likedProducts.includes(item._id));
    }, [item._id]);

    // Handle like button click
    const handleLikeClick = (e) => {
        e.stopPropagation();
        e.preventDefault();

        const likedProducts = getLikedProducts();
        if (likedProducts.includes(item._id)) {
            // Remove from liked products
            const updatedLikedProducts = likedProducts.filter((id) => id !== item._id);
            saveLikedProducts(updatedLikedProducts);
            setIsLiked(false);
        } else {
            // Add to liked products
            likedProducts.push(item._id);
            saveLikedProducts(likedProducts);
            setIsLiked(true);
        }
    };
    // console.log(item._id)
    return (
        <Link onClick={() => saveRecentlyView(item)} className='product-card' to={`/${CATALOG_MAIN_LINK}/${buildCategoryPath(reversedArray, item.categories[0].parents.length - 1)}/${CATALOG_ITEM_LINK}/${item._id}`}>
            <button className={`product-card__like ${isLiked ? 'product-card__like_active' : ''}`} type='button' onClick={handleLikeClick}>
                <svg className='product-card__like-icon' width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className='product-card__like-icon-fill-and-stroke' d="M17.5173 3C21.3979 3 24 6.725 24 10.1938C24 17.235 13.1968 23 13 23C12.8032 23 2 17.235 2 10.1938C2 6.725 4.60211 3 8.48267 3C10.701 3 12.1579 4.13125 13 5.13875C13.8421 4.13125 15.299 3 17.5173 3Z" fill="white" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
            <div className='product-card__image-box'>
                {ENABLE_PHOTO_AUTOADJUST ?
                    < ImageWithBackground
                        className={`product-card__image product-card__image_format_10x16`}
                        src={item.files && item.files.length > 0 ? item.files[0]?.urls?.orig : IMG_PLACEHOLDER_PRODUCT}
                        image_format={'10x16'}
                        key={`${item.files && item.files.length > 0 ? item.files[0].urls.orig : IMG_PLACEHOLDER_PRODUCT}${item._id}`}
                        metadata={item.files && item.files.length > 0 ? item.files[0]?.metadata : null}
                        isVideo={item.files && item.files[0]?.metadata?.first_frame_db ? true : false}
                    />
                    :
                    <img
                        className={`product-card__image product-card__image_format_10x16`}
                        src={item.files && item.files.length > 0 ? item.files[0]?.metadata?.first_frame_db ? item.files[0]?.metadata?.first_frame_db.urls?.orig : item.files[0]?.urls?.orig : IMG_PLACEHOLDER_PRODUCT}
                        alt=''
                    ></img>
                }
            </div>
            <div className='product-card__additional product-card__additional_pc'>
                {item.parameters?.find((item2) => item2.name === '_promo')?.value ? <p className='product-card__additional-promo'>{item.parameters?.find((item2) => item2.name === '_promo')?.value}</p> : <div />}
                {item.parameters?.find((item2) => item2.name === 'Состояние')?.value ? <p className='product-card__additional-condition'>{item.parameters?.find((item2) => item2.name === 'Состояние')?.value}</p> : <div className='product-card__additional-condition-placeholder' />}
            </div>
            <div className='product-card__info'>
                {/* // style={{ position: 'relative' }}> */}
                <div className='product-card__condition-and-material'>
                    {/* <p className='product-card__condition'>{item.parameters?.find((item2) => item2.name === 'Состояние') && item.parameters ? POSSIBLE_CONDITION?.includes(item.parameters?.find((item2) => item2.name === 'Состояние')?.value) ? item.parameters?.find((item2) => item2.name === 'Состояние')?.value : null : ''}</p> */}
                    <p className='product-card__material'>
                        {item.parameters?.find((item2) => item2.name === 'Материал корпуса') && item.parameters?.find((item2) => item2.name === 'Материал корпуса').value && item.parameters ?
                            item.parameters?.find((item2) => item2.name === 'Материал корпуса')?.value.includes('золото') ?
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <rect x="0.7" y="0.7" width="14.6" height="14.6" rx="7.3" stroke="black" stroke-width="1.4" />
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 0C3.58164 0 0 3.58174 0 8C0 12.4183 3.58164 16 8 16V0Z" fill="black" />
                                </svg> :
                                item.parameters?.find((item2) => item2.name === 'Материал корпуса')?.value.includes('титан') ?
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                        <path d="M0.98995 9L9 0.98995L17.01 9L9 17.01L0.98995 9Z" stroke="black" stroke-width="1.4" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9 0L0 9L9 18V0Z" fill="black" />
                                    </svg>
                                    : item.parameters?.find((item2) => item2.name === 'Материал корпуса')?.value.includes('серебро') ?
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                            <path d="M0.98995 9L9 0.98995L17.01 9L9 17.01L0.98995 9Z" stroke="black" stroke-width="1.4" />
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9 0L0 9L9 18V0Z" fill="black" />
                                        </svg>
                                        : item.parameters?.find((item2) => item2.name === 'Материал корпуса')?.value.includes('платина') ?
                                            <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                                                <rect width="34" height="34" rx="17" fill="black" />
                                                <path d="M16.9996 5.09998L20.0073 12.8602L28.3172 13.3227L21.8662 18.5812L23.9943 26.6273L16.9996 22.117L10.005 26.6273L12.1331 18.5812L5.68204 13.3227L13.9919 12.8602L16.9996 5.09998Z" fill="white" />
                                            </svg>
                                            : null
                            : null}
                    </p>
                </div>
                {item.price_data.discount && item.price_data.discount > 0 ?
                    <h3 className='product-card__price-discount'>-{item.price_data.discount}%</h3>
                    :
                    null
                }
                <div>
                    <h3 className={`product-card__title`}>{item.name && item.name.length > 0 ? parseTitleForParts(item.name).title : ` `}</h3>
                    <p className={`product-card__subtitle`}>{item.name && item.name.length > 0 ? parseTitleForParts(item.name).subtitle : ` `}</p>
                </div>
                <div className='product-card__additional product-card__additional_mobile'>
                    {item.parameters?.find((item2) => item2.name === '_promo')?.value ? <p className='product-card__additional-promo'>{item.parameters?.find((item2) => item2.name === '_promo')?.value}</p> : <div />}
                    {item.parameters?.find((item2) => item2.name === 'Состояние')?.value ? <p className='product-card__additional-condition'>{item.parameters?.find((item2) => item2.name === 'Состояние')?.value}</p> : <div className='product-card__additional-condition-placeholder' />}
                </div>
                {/* <p className={`product-card__description`}>{item.description && item.description.length > 0 ? item.description : ` `}</p> */}
                {/* <div className='product-card__separator'></div> */}
                {/* <button className={`product-card__button   `} type='button' onClick={(e) => handleCartClick(e)}> */}
                {/* {item.price_data.discount && item.price_data.discount > 0 ?
                    <h3 className='product-card__button-price product-card__button-price_discount'><span className='product-card__button-price-discounted'>{parsePrice(Number(price), 'USD')}</span> {item.options && item.options.length === 1 ? 'от ' : ''}{parsePrice(Math.round(Number(price) - Number(price) / 100 * Number(item.price_data.discount)), 'USD')}</h3>
                    :
                    <h3 className='product-card__button-price product-card__button-price_discount'><span className='product-card__button-price-discounted product-card__button-price-discounted_unvisible'>{0}</span> {item.options && item.options.length === 1 ? 'от ' : ''}{parsePrice(Math.round(Number(price) - Number(price) / 100 * Number(item.price_data.discount)), 'USD')}</h3>

                    // <h3 className='product-card__button-price'>{item.options && item.options.length === 1 ? 'от ' : ''}{parsePrice(price, 'USD')}</h3>
                } */}
                <div className='product-card__button'>
                    {
                        item?.parameters?.find((item2) => item2.name === ARTICL_NAME)
                            ?
                            <div className='product-card__button__reference'>
                                Референс:
                                <p className='product-card__button__reference__value'>{item?.parameters?.find((item2) => item2.name === ARTICL_NAME).value}</p>
                            </div>
                            :
                            <div className='product-card__button__reference-placeholder'>

                            </div>
                    }

                    {price && Number(price) !== 0 && Number(price) !== 1 ?
                        item.price_data.discount && item.price_data.discount > 0 ?
                            <h3 className='product-card__button-price product-card__button-price_discount'><span className='product-card__button-price-discounted'>{parsePrice(Number(price), 'USD')}</span> {item.options && item.options.length === 1 ? 'от ' : ''}{parsePrice(Math.round(Number(price) - Number(price) / 100 * Number(item.price_data.discount)), 'USD')}</h3>
                            :
                            <h3 className='product-card__button-price'>{item.options && item.options.length === 1 ? 'от ' : ''}{parsePrice(price, 'USD')}</h3>
                        :
                        <h3 className='product-card__button-price-request'>По запросу</h3>
                    }
                </div>
                {/* {in_stock ?
                    <div className={`product-card__button-to-cart ${inCart ? "product-card__button_in-cart" : ""}`}>
                        <p className='product-card__button-to-cart-text'>{in_cart_text}</p>
                    </div>
                    :
                    <div className='product-card__button-to-cart product-card__button-to-cart_not-in-stok'>
                        <p className='product-card__button-to-cart-text'>Нет в наличии</p>
                    </div>
                } */}
                {/* </button> */}
            </div>
        </Link>
    );
}

export default ProductCard